import type { ApiResponse } from "~/types/ApiResponse";
import type { User } from "~/models/User";

export default defineNuxtPlugin(() => {
    const echo = useEcho();

    const authenticatedUsers = ref<User[]>([]);
    const authenticatedChannel = ref<ReturnType<typeof useEcho>["join"]>();

    watchImmediate(
        useSanctumUser<ApiResponse<User>>(),
        async (toUser, fromUser) => {
            if (toUser) {
                authenticatedChannel.value = echo
                    .join(`online.${toUser.data.account.id}`)
                    .here((users: any) => {
                        authenticatedUsers.value = users;
                    })
                    .joining((user: any) => {
                        authenticatedUsers.value = [
                            user,
                            ...authenticatedUsers.value,
                        ];
                    })
                    .leaving((user: any) => {
                        authenticatedUsers.value =
                            authenticatedUsers.value.filter(
                                (existing) => existing.id !== user.id,
                            );
                    });
            } else if (fromUser) {
                authenticatedChannel.value = undefined;
            }
        },
    );

    return {
        provide: {
            authenticatedChannel,
            authenticatedUsers,
        },
    };
});
